import { Typography } from '@mui/material'

export default function SpacesHomePage() {
  return (
    <div>
      <h1>Welcome!</h1>
      <Typography variant="h2" align="center">
        Select a type or collection to start!
      </Typography>
    </div>
  )
}
